//
// Copyright 2020 Emerald Associates, Inc.  All Rights Reserved.
//
// Use of this file other than by Emerald Associates, Inc. is forbidden
// unless otherwise authorized by a separate written license agreement.
//
// $Id$
//
import React from "react";
import ReactDOM from "react-dom";
import AuditorApplication from "src/components/auditor/AuditorApplication";
import * as wjcCore from "@grapecity/wijmo";

function App() {
  initializeGlobals();
  return (
    <div>
      <AuditorApplication />
    </div>
  );
}

function initializeGlobals() {
  // By default, Wijmo formats dates without the time (ie. MM/dd/yyyy)
  // Change it to include the time
  const oldFn = wjcCore.Globalize.formatDate;
  wjcCore.Globalize.formatDate = function (value, format) {
    // override default "d" format
    if (format === "d") {
      return oldFn.call(this, value, "MM/dd/yyyy hh:mm tt");
    } else {
      return oldFn.call(this, value, format);
    }
  };
}

ReactDOM.render(<App />, document.getElementById("root"));
